// @ts-nocheck
import React from 'react';
import EventManagementStaffing from '@/pages/admin/event-management/EventManagementStaffing';

const DemoStaffing: React.FC = () => {
  return <EventManagementStaffing />;
};

export default DemoStaffing;
